export const WHATSAPP_NUMBER = "919270303567";
export const WHATSAPP_DISPLAY = "+91 92703 03567";
export const BUSINESS_NAME = "Deal 2 Wheel";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
